import bodymovin from 'lottie-web';



const initContactAnimation = (container = document) => {
  console.log('init contact animation');
  const animation = bodymovin.loadAnimation({
    container: container.querySelector('#animation'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: 'public/animations/kontakt.json'
  });
}



export default initContactAnimation;
